// myDSA fonts https://docs.google.com/spreadsheets/d/14erZFt9PJveWWGpREvl_pxXNjnFvCeVx25ij5MHUx1k/edit?gid=0#gid=0
export const typography = {
  notificationErrorBody: {
    className: "text-body-sm text-red-700",
    text: "Be sure you are using your DSA email.",
  },
  notificationErrorHeading: {
    className: "text-label-sm text-red-800",
    text: "You are not eligible to create an account",
  },
  formInput: {
    className: "text-base leading-6 font-normal text-gray-900",
    text: "name@example.com",
  },
  formInputLabel: {
    className: "text-label-sm text-gray-700",
    text: "Email address",
  },
  formInputSubtitle: {
    className: "text-body-sm text-gray-500",
    text: "Use your DSA email address to continue.",
  },
  formPageSubtitle: {
    className: "text-body-sm text-gray-600",
    text: "We sent an email to the address you provided with instructions to how to verify your email address.",
  },
  formPageTitle: {
    // Figma incorrectly labels "extrabold" as 700
    className: "text-3xl leading-9 font-heavy text-gray-900",
    text: "Sign in to MyDSA",
  },
  formSectionHeading: {
    className: "text-lg leading-6 font-medium text-gray-900",
    text: "Contact information",
  },
  formSubtitle: {
    className: "text-base leading-6 font-medium text-gray-700",
    text: "Enter your email to continue.",
  },
  profileDetail: {
    className: "text-label-sm text-gray-600",
    text: "Member since 2024",
  },
  profileInfo: {
    className: "text-label-sm text-gray-800",
    text: "Your mailing address is used for physical mail, such as your membership card and copies of Democratic Left.",
  },
  profileLink: {
    className: "text-label-sm text-sky-500 underline",
    text: "Send Proof of Membership",
  },
  profileTitleDesktop: {
    className: "text-2xl leading-8 font-bold text-gray-900",
    text: "Jane Doe",
  },
  profileTitleMobile: {
    className: "text-xl leading-7 font-bold text-gray-900",
    text: "Jane Doe",
  },
  notificationWarning: {
    className: "text-label-sm text-yellow-800",
    text: "MyDSA is currently in limited beta, available to select members in good standing.",
  },
  formLink: {
    className: "text-label-sm text-dsa-red",
    text: "Forgot your password?",
  },
  buttonPrimaryLabel: {
    className: "text-label-sm text-white",
    text: "Sign in",
  },
} as const;

export type TypographyKey = keyof typeof typography;
